import React from "react";
import {
  List,
  Datagrid,
  Edit,
  Create,
  SimpleForm,
  TextField,
  DateField,
  EditButton,
  TextInput,
  
  ReferenceInput,
  SelectInput,
  DateTimeInput,
  translate,
  FunctionField,
  Show,
  SimpleShowLayout,

  ListButton,
  Filter
} from "react-admin";
import { CardActions } from "@material-ui/core";
import {
    required,
    password,
    passwordEdit,
    passwordEquals
} from "../../validators/validators";

const DeviceFilter = props => (
  <Filter {...props}>
    <TextInput
      elStyle={{ width: 380 }}
      label="resources.misc.fields.id"
      source="id"
    />
    <TextInput
      elStyle={{ width: 380 }}
      label="resources.misc.fields.name"
      source="name"
    />
  </Filter>
);

export const DeviceList = props => (
  <List {...props} exporter={false} filters={<DeviceFilter />}  bulkActionButtons={false}>
    <Datagrid>
      <TextField label="resources.misc.fields.manufacturer" source="manufacturer" />
       <EditButton label={""}/>
    </Datagrid>
  </List>
);

const DeviceTitle = ({ record }) => {
    return (
      <span>{record ? `Naprava ${record.manufacturer || ""}` : ""}</span>
    );
};

const cardActionStyle = {
    zIndex: 2,
    display: "inline-block",
    float: "right"
};

const Actions = ({ basePath, data, refresh }) => (
  <CardActions style={cardActionStyle}>
    <EditButton basePath={basePath} record={data} />
    <ListButton basePath={basePath} />
  </CardActions>
);

export const DeviceShow = props => (
  <Show title={<DeviceTitle />} actions={<Actions />} {...props}>
    <SimpleShowLayout>
      <TextField label="resources.misc.fields.manufacturer" source="manufacturer" />
    </SimpleShowLayout>
  </Show>
);

export const DeviceEdit = ({ permissions, ...props }) => (
  <Edit title={<DeviceTitle />} actions={<CardActions />} {...props}>
    <SimpleForm>
      <TextInput
        label="resources.misc.fields.manufacturer"
        source="manufacturer"
      />
    </SimpleForm>
  </Edit>
);

export const DeviceCreate = ({ permissions, ...props }) => (
  <Create title="Nova naprava" {...props}>
    <SimpleForm redirect="list">
    <TextInput
        label="resources.misc.fields.manufacturer"
        source="manufacturer"
      />
    </SimpleForm>
  </Create>
);